const dutchLocaleList = [
  "nl", "nl-AW", "nl-BE", "nl-BQ", "nl-CW", "nl-NL", "nl-SR", "nl-SX"
];

export default {
  dutchLocaleList
}